'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useState } from 'react';
import { AuthApi } from '@/api';
import { DONATION_ROUTES, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useLoginGuard } from '@/hooks/useLoginGuard';
import { MARKET_EVENT_END_AT } from '../constants';
import { MarketButton } from './MarketButton';
import { MarketShareDrawer } from './MarketShareDrawer';
import { type ModalType, RandomTicketModal } from './RandomTicketModal';
interface RandomDrawClientProps {
  className?: string;
  children?: React.ReactNode;
  dimensions?: 'H56' | 'H48' | 'H40' | 'H32' | 'H26' | null | undefined;
}
interface ModalState {
  type: ModalType;
  point: number;
}
export const RandomDrawClient = t0 => {
  const $ = _c(29);
  const {
    className,
    children,
    dimensions
  } = t0;
  const {
    push
  } = useCustomRouter();
  const loginGuard = useLoginGuard();
  const {
    toastError
  } = useToast();
  const [modalState, setModalState] = useState(null);
  const [isShareDrawerOpen, setIsShareDrawerOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = dayjs().isAfter(dayjs(MARKET_EVENT_END_AT));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isEventEnded = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = result => setModalState(result);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== toastError) {
    t3 = {
      mutationFn: _temp,
      onSuccess: t2,
      onError: error => toastError({
        error
      })
    };
    $[2] = toastError;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    mutate,
    isPending
  } = useMutation(t3);
  let t4;
  if ($[4] !== loginGuard || $[5] !== mutate) {
    t4 = () => {
      if (!loginGuard()) {
        return;
      }
      mutate();
    };
    $[4] = loginGuard;
    $[5] = mutate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleClick = t4;
  let t5;
  if ($[7] !== modalState || $[8] !== push) {
    t5 = () => {
      if (!modalState) {
        return;
      }
      setModalState(null);
      bb48: switch (modalState.type) {
        case "win":
          {
            push(ROUTES.POINT_MARKET.pathname);
            break bb48;
          }
        case "not-eligible":
          {
            push(DONATION_ROUTES.HOME.pathname);
            break bb48;
          }
        case "already-participated":
          {
            setIsShareDrawerOpen(true);
          }
      }
    };
    $[7] = modalState;
    $[8] = push;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handlePrimaryClick = t5;
  const t6 = isPending || isEventEnded;
  const t7 = isEventEnded ? "\uC774\uBCA4\uD2B8\uAC00 \uC885\uB8CC\uB410\uC5B4\uC694" : children;
  let t8;
  if ($[10] !== className || $[11] !== dimensions || $[12] !== handleClick || $[13] !== t6 || $[14] !== t7) {
    t8 = <MarketButton dimensions={dimensions} className={className} onClick={handleClick} disabled={t6}>{t7}</MarketButton>;
    $[10] = className;
    $[11] = dimensions;
    $[12] = handleClick;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = modalState !== null;
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setModalState(null);
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = modalState?.type ?? "win";
  const t12 = modalState?.point ?? 0;
  let t13;
  if ($[17] !== handlePrimaryClick || $[18] !== t11 || $[19] !== t12 || $[20] !== t9) {
    t13 = <RandomTicketModal isOpen={t9} onClose={t10} type={t11} point={t12} onPrimaryClick={handlePrimaryClick} />;
    $[17] = handlePrimaryClick;
    $[18] = t11;
    $[19] = t12;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsShareDrawerOpen(false);
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== isShareDrawerOpen) {
    t15 = <MarketShareDrawer opened={isShareDrawerOpen} onClose={t14} />;
    $[23] = isShareDrawerOpen;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t13 || $[26] !== t15 || $[27] !== t8) {
    t16 = <>{t8}{t13}{t15}</>;
    $[25] = t13;
    $[26] = t15;
    $[27] = t8;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
};
async function _temp() {
  const {
    data
  } = await AuthApi["get:/wello/v2/auth/home/event/december/random-ticket-count"]();
  const context = data?.context;
  if (!context) {
    throw new Error("context is empty");
  }
  const {
    randomTicketId: random_ticket_id,
    event2AvailYN: event2_avail_yn
  } = context;
  if (random_ticket_id === null) {
    return {
      type: (event2_avail_yn ? "not-eligible" : "already-participated") as ModalType,
      point: 0
    };
  }
  const {
    data: openData
  } = await AuthApi["put:/wello/v2/auth/home/event/december/random-ticket/{randomTicketId}"]({
    path: {
      randomTicketId: random_ticket_id
    }
  });
  const pointContext = openData?.context;
  if (!pointContext?.resultYN) {
    throw new Error(pointContext?.message || "\uC6F0\uD3EC\uC778\uD2B8 \uC9C0\uAE09\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
  }
  return {
    type: "win" as ModalType,
    point: pointContext.addPoints
  };
}